import { forwardRef } from 'react';

export const CheckmarkIconColored = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="16" cy="16" r="16" fill="currentColor" />
        <path
          d="M13.5 19.475L10.025 16L8.84166 17.175L13.5 21.8333L23.5 11.8333L22.325 10.6583L13.5 19.475Z"
          fill="white"
        />
      </svg>
    );
  },
);
